import { Checkbox } from "./chadcn/Checkbox";

type CheckboxLabelProps = {
  label: string;
  checked: boolean | "indeterminate";
  onCheckedChange: () => void;
};

const CheckboxLabel = ({ label, checked, onCheckedChange }: CheckboxLabelProps) => (
  <label className="flex cursor-pointer items-center gap-1.5 text-sm text-primary/90">
    <Checkbox checked={checked} onCheckedChange={onCheckedChange} />
    {label}
  </label>
);

export default CheckboxLabel;
